import { ADD_ASSIGNED_USER_TO_ARCHIVED_TASK, CHANGE_ARCHIVE_TASK_DONE_FILTER, CHANGE_ARCHIVED_TASK_DONE_STATUS, EDIT_ARCHIVED_TASK, REMOVE_ARCHIVED_TASK, REMOVE_ASSINGED_USER_FROM_ARCHIVED_TASK, SET_ARCHIVE_FILTERED_PIPELINE, SET_ARCHIVE_SEARCH_VALUE, SET_ARCHIVE_TASKS, } from "../constants";
import { convertTaskFromServer } from "../utils/task";
const reducer = (state, action) => {
    var _a, _b, _c, _d, _e;
    switch (action.type) {
        case SET_ARCHIVE_TASKS: {
            const archivedTasks = action.payload;
            return Object.assign(Object.assign({}, state), { archivedTasks: archivedTasks.map(convertTaskFromServer) });
        }
        case SET_ARCHIVE_SEARCH_VALUE: {
            const archiveSearchValue = action.payload;
            return Object.assign(Object.assign({}, state), { archiveSearchValue });
        }
        case SET_ARCHIVE_FILTERED_PIPELINE: {
            const archiveFilteredPipelineId = action.payload;
            return Object.assign(Object.assign({}, state), { archiveFilteredPipelineId });
        }
        case REMOVE_ARCHIVED_TASK: {
            const archivedTasks = ((_a = state.archivedTasks) !== null && _a !== void 0 ? _a : []).filter((task) => task.id !== action.payload);
            return Object.assign(Object.assign({}, state), { archivedTasks });
        }
        case ADD_ASSIGNED_USER_TO_ARCHIVED_TASK: {
            const { taskId, user } = action.payload;
            const archivedTasks = ((_b = state.archivedTasks) !== null && _b !== void 0 ? _b : []).map((task) => {
                if (task.id === taskId) {
                    return Object.assign(Object.assign({}, task), { assigned_users: [user, ...task.assigned_users] });
                }
                return task;
            });
            return Object.assign(Object.assign({}, state), { archivedTasks });
        }
        case REMOVE_ASSINGED_USER_FROM_ARCHIVED_TASK: {
            const { taskId, user } = action.payload;
            const archivedTasks = ((_c = state.archivedTasks) !== null && _c !== void 0 ? _c : []).map((task) => {
                if (task.id === taskId) {
                    return Object.assign(Object.assign({}, task), { assigned_users: task.assigned_users.filter((assignedUser) => assignedUser.id !== user.id) });
                }
                return task;
            });
            return Object.assign(Object.assign({}, state), { archivedTasks });
        }
        case CHANGE_ARCHIVED_TASK_DONE_STATUS: {
            const { taskId, done } = action.payload;
            const archivedTasks = ((_d = state.archivedTasks) !== null && _d !== void 0 ? _d : []).map((task) => {
                if (task.id === taskId) {
                    return Object.assign(Object.assign({}, task), { is_done: done });
                }
                return task;
            });
            return Object.assign(Object.assign({}, state), { archivedTasks });
        }
        case EDIT_ARCHIVED_TASK: {
            const editedTask = action.payload;
            const archivedTasks = ((_e = state.archivedTasks) !== null && _e !== void 0 ? _e : []).map((task) => {
                if (task.id === editedTask.id) {
                    return convertTaskFromServer(editedTask);
                }
                return task;
            });
            return Object.assign(Object.assign({}, state), { archivedTasks });
        }
        case CHANGE_ARCHIVE_TASK_DONE_FILTER: {
            const archiveTaskDoneFilter = action.payload;
            return Object.assign(Object.assign({}, state), { archiveTaskDoneFilter });
        }
        default: {
            return state;
        }
    }
};
export { reducer };
